import React from 'react'
import fail from '../Assets/cancel.png'
import { Link } from 'react-router-dom'

const Fail = () => {
  return (
    <div className='success-bg'>
      <div className="content-status">
        <img src={fail} className='successimage' alt="" />
        <h1 className='payment-text'>Payment Failed</h1>
        <p className='payment-sub'>Please try again!</p>
        <Link to='/' className='btn-try'>Try Again</Link>
      </div>
    </div>
  )
}

export default Fail;